import Swiper, { Navigation } from 'swiper';

export function infoSlider(element) {
    
    function swiperMode() {
        let mobile = window.matchMedia('(min-width: 0px) and (max-width:1300px)');
        let desktop = window.matchMedia('(min-width: 1300px)');
        var init = false;

        
        if(mobile.matches) {
            if (!init) {
                init = true;
                const swiper = new Swiper( element, {
                        modules: [Navigation],
                        slidesPerView: 'auto',
                        loop: false,
                        navigation: {
                            nextEl: ".swiper-button-next"
                        }
                    }
                );
            }
        } // Disable (for desktop)
        else if(desktop.matches) {
            if (init) {
                swiper.destroy();
                init = false;
            }
            
        }
    }

     /* On Load
    **************************************************************/
    window.addEventListener('load', function() {
        swiperMode();
    });

    /* On Resize
    **************************************************************/
    window.addEventListener('resize', function() {
        swiperMode();
    });

}
